<template>
  <header class="website-header">
    <div class="container com-size">
      <!-- Logo区域 -->
      <div class="logo-wrapper">
        <router-link to="/" class="logo">
          <img src="@/assets/images/home/logo.png" alt="网站Logo" />
        </router-link>
      </div>
      <!-- 菜单按钮 -->
      <div class="work-btns">
        <a href="https://oa.ahgkjt.com/seeyon/main.do?method=main" target="_blank">
          <img src="@/assets/images/home/computer.png" alt="" />
          OA办公
        </a>
        <!-- <a-popover title="" trigger="hover">
          <img src="@/assets/images/home/wechat.png" alt="" />
          <template slot="content">
            <img src="../assets/images/home/wecode.jpg" alt="" />
          </template>
        </a-popover> -->
      </div>
      <!-- 搜索框 -->
      <!-- <div class="search-panel">
        <a-input-search
          v-model="strSearch"
          placeholder="站内搜索"
          @search="performSearch"
        />
      </div> -->
    </div>
  </header>
</template>

<script>
export default {
  name: 'WebsiteHeader',
  data() {
    return {
      strSearch: '', //头部搜索词
    }
  },
  mounted() {
    this.strSearch = this.$route?.query?.q || ''
  },
  beforeDestroy() {
  },
  methods: {
    performSearch() {
      // console.log(this.strSearch,'this.strSearch')
      if (this.strSearch.trim()) {
        // 执行搜索操作
        this.$router.push(`/list?q=${encodeURIComponent(this.strSearch)}`)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.website-header {
  position: fixed;
  top: 0;
  left: 0;
  // height: 38px;
  width: 100%;
  padding: 15px 0;
  // background: linear-gradient(90deg, #d80014 0%, #e0480e 81%, #d80014 100%);
  background-color: #fff;
  z-index: 1000;
  transition: all 0.3s ease;

  // 滚动时的样式
  &.is-scrolled {
    background-color: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 12px 0;

    .logo-text,
    .nav-list a {
      color: #333;
    }

    .action-btn,
    .current-lang {
      color: #333;
    }
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }
  .work-btns {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #333;
    a {
      margin-left: 5px;
      padding-right: 10px;
      position: relative;
      margin-right: 15px;
      color: #333;
      display: flex;
      align-items: center;
      img {
        margin-right: 5px;
      }
      &::after {
        content: '';
        position: absolute;
        width: 1px;
        height: 15px;
        background: #ffffff;
        opacity: 0.25;
        right: 0;
      }
    }
    > img {
      cursor: pointer;
    }
  }

  // Logo样式
  .logo-wrapper {
    .logo {
      display: flex;
      align-items: center;
      text-decoration: none;

      img {
        height: 100%;
        margin-right: 10px;
      }

      .logo-text {
        font-size: 24px;
        font-weight: 700;
        color: #fff;
        transition: color 0.3s ease;
      }
    }
  }

  // 搜索面板
  ::v-deep .search-panel {
    .container {
      display: flex;
      align-items: center;
    }

    .ant-input:focus,
    .ant-input {
      border: none;
      width: 188px;
      height: 28px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 14px;
      color: #fff;
      &::placeholder {
        color: #fff;
      }
    }
    .ant-input-search-icon {
      color: #fff;
      font-size: 14px;
    }

    .close-search {
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      padding: 5px;
      color: #999;

      &:hover {
        color: #333;
      }
    }
  }
}

// 媒体查询 - 响应式设计
@media (max-width: 992px) {
  .website-header {
    .logo-wrapper {
      order: 1;
      flex: 1;
    }
  }
}

@media (max-width: 576px) {
  .website-header {
    padding: 15px 0;

    &.is-scrolled {
      padding: 10px 0;
    }

    .logo-wrapper .logo {
      img {
        height: 30px;
      }

      .logo-text {
        font-size: 18px;
      }
    }
  }
}
</style>
